export enum StorageType {
  UNC = "UNC",
  FTP = "FTP",
  DIVA = "DIVA",
  SNSM = "SNSM",
  ASPERA = "ASPERA",
  FACEBOOK = "FACEBOOK",
  AMAZONS3 = "AMAZONS3",
}
